import { QueryPartData } from '../base/entities/query-part-data.entity';
import { QueryPart } from '../base/entities/query-part.class';
import { IFilterData } from './filter-data.entity';
import isEqual from 'lodash-es/isEqual';

// @dynamic
export class FilterHelper {
    static loadQueryPart(filter: IFilterData, queryPart: QueryPartData): IFilterData {
        if (queryPart.field !== filter.field) {
            console.error(`queryPart and filter fields don't match`);
        }

        return {
            ...filter,
            values: [...filter.values, ...queryPart.values],
            strategy: queryPart.strategy
        };
    }

    static loadValues(filter: IFilterData, values: string[]): IFilterData {
        const valuesToAdd: string[] = this.getValuesToAdd(filter, values);

        return {
            ...filter,
            values: [...filter.values, ...valuesToAdd]
        };
    }

    static addValue(filter: IFilterData, value: string): IFilterData {
        const valuesToAdd: string[] = this.getValuesToAdd(filter, [value]);

        return {
            ...filter,
            values: [...filter.values, ...valuesToAdd]
        };
    }

    private static getValuesToAdd(filter: IFilterData, values: string[]): string[] {
        return values.filter(value => value && !filter.values.includes(value));
    }

    static clearValues(filter: IFilterData): IFilterData {
        return {
            ...filter,
            values: []
        };
    }

    static hasValues(filter: IFilterData): boolean {
        return Array.isArray(filter) && filter.values.length > 0;
    }

    static getQueryPart(filter: IFilterData): QueryPart {
        return new QueryPart({ field: filter.field, strategy: filter.strategy, values: filter.values });
    }

    /**
     * Use this to check if the filters are roughly the same. Values are not compared.
     */
    static isSimilar(f1: IFilterData, f2: IFilterData): boolean {
        return f1.field === f2.field && f1.filterType === f2.filterType && f1.strategy === f2.strategy;
    }

    /**
     * Strict comparison
     */
    static isIdentical(f1: IFilterData, f2: IFilterData): boolean {
        return isEqual(f1, f2);
    }
}
